import { render } from "./SecondaryBtn.vue?vue&type=template&id=9a5a97b2&scoped=true"
import script from "./SecondaryBtn.vue?vue&type=script&lang=js"
export * from "./SecondaryBtn.vue?vue&type=script&lang=js"

import "./SecondaryBtn.vue?vue&type=style&index=0&id=9a5a97b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a5a97b2"]])

export default __exports__